// extracted by mini-css-extract-plugin
export default {"container":"modals_container__3szJB","modals":"modals_modals__4Swp5","hasModals":"modals_hasModals__1OIEE"};